import { bootstrapApplication } from "@angular/platform-browser";
import { AppComponent } from "./app/app.component";
import { appConfig } from "./app/app.config";
import { environment } from "@environment/environment";

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then(registrations => {
    for (const registration of registrations) {
      registration.unregister();
    }
  });
}

function bootstrap() {
  bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
}

if (environment.mockEnabled) {
  import("./mocks/browser").then(({ worker }) => {
    worker.start({ onUnhandledRequest: "bypass" }).then(bootstrap);
  });
} else {
  bootstrap();
}
